import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateJourneyTemplateRequest extends BaseUpdateRequest {
	name = '';
    distanceOneWay = 0;
    travelTimeOneWay = 0;
}